import { rest } from '@0xtorch/core'
import { z } from 'zod'
import type { TestApiAuthentication } from '../types'
import { bybitApiEndpoint } from './constants'
import { commonResponseSchema, successReponseSchema } from './schemas'
import { createPrivateGetHeaders } from './utils'

const responseSchema = successReponseSchema.extend({
  result: z.unknown(),
})

export const testBybitApiAuthentication: TestApiAuthentication = async ({
  apiKey,
  apiSecret,
  proxy,
  proxyHeaders,
}) => {
  const url = new URL('/v5/account/info', bybitApiEndpoint)

  const response = await rest(
    proxy === undefined
      ? url.toString()
      : `${proxy}${encodeURIComponent(url.toString())}`,
    {
      fetchOptions: {
        method: 'GET',
        headers: {
          ...proxyHeaders,
          ...(await createPrivateGetHeaders({
            apiKey,
            apiSecret,
            query: '',
          })),
        },
      },
      schema: z.union([responseSchema, commonResponseSchema]),
    },
  )

  if (!('result' in response)) {
    return false
  }

  return true
}
